module.exports = __webpack_public_path__ + "img/blue.7ba9999d.png";